import { AlertDialog, Button } from '@buffer-mono/popcorn'

import type { SavedReply } from '~publish/gql/graphql'

type DiscardReplyDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  savedReply: SavedReply
  onCancelDeleting: () => void
  onKeepDeleting: () => void
}

export const DiscardDeleteSavedReplyDialog = ({
  open,
  onOpenChange,
  savedReply,
  onCancelDeleting,
  onKeepDeleting,
}: DiscardReplyDialogProps): JSX.Element => {
  const savedReplyName = savedReply?.title
    ? savedReply.title.slice(0, 30)
    : savedReply.content.text.slice(0, 30)

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Content>
        <AlertDialog.Title>Delete Saved Reply</AlertDialog.Title>
        <AlertDialog.Description>
          Your Saved Reply{' '}
          {savedReplyName ? <strong>&apos;{savedReplyName}&apos;</strong> : ''}{' '}
          will be deleted permanently. This cannot be undone.
        </AlertDialog.Description>
        <AlertDialog.Actions>
          <AlertDialog.Cancel onClick={onCancelDeleting}>
            <Button variant="tertiary">Cancel</Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action onClick={onKeepDeleting}>
            <Button variant="critical">Delete Saved Reply</Button>
          </AlertDialog.Action>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
